'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trafficManager = require('./traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _surveyDataNotifier = require('./survey-data-notifier');

var _surveyDataNotifier2 = _interopRequireDefault(_surveyDataNotifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previousIntent = '';

/**
 * Return the id of last intent in given conversation
 * @param {object} conversation array of messages from bot and users
 * @returns {string | null} return the string if there is at least one intent in the conversation, otherwise, return null.
 */
var findLastIntentId = function findLastIntentId(conversation) {
  for (var i = conversation.length - 1; i >= 0; i--) {
    if (conversation[i].intent) {
      return conversation[i].intent.name.split('/agent/intents/')[1];
    }
  }

  return null;
};

/*
* String starts with function - safe for Internet Explorer
* MDN starts with was ECMA 2015 only and therefore IE does not support.
*/
var stringStartsWith = function stringStartsWith(val, search) {
  return val.lastIndexOf(search, 0) === 0;
};
/**
 * Central method for handling intent for a dialogflow response
 *
 * @param {Object} bot The bot for which a traffic event is being created
 * @param {Object} response The response object from Dialogflow
 * @param {boolean} isEscalation Value representing whether escalation is required
 * @param {string} botProjectId The bot project the user is in
 * @private
 */
var notifyIntent = function notifyIntent(bot, response, isEscalation, botProjectId) {
  var intent = response.queryResult.intent.displayName;
  var id = response.queryResult.intent.name.split('/agent/intents/')[1];
  var _bot$props = bot.props,
      sessionId = _bot$props.sessionId,
      productId = _bot$props.productId;


  if (stringStartsWith(intent, '0.9.1 ')) {
    _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.offered', [['intent', intent], ['id', id], ['bsid', sessionId], ['product', productId]]);
  }

  if (stringStartsWith(intent, '0.9.2 ')) {
    _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.phone', [['intent', intent], ['id', id], ['bsid', sessionId], ['product', productId]]);
  }

  _trafficManager2.default.sendEvent('custom', 'cx.help-bot.bot.intent', [['intent', intent], ['id', id], ['bsid', sessionId], ['utterance', response.queryResult.queryText], ['fallback', response.queryResult.intent.isFallback], ['escalation', isEscalation ? isEscalation : false], ['product', productId], ['previous', previousIntent]]);

  _surveyDataNotifier2.default.notifyBotIntent(botProjectId, {
    intent: intent,
    id: id,
    bsid: sessionId,
    product: productId
  });

  previousIntent = intent;
};

exports.default = {
  notifyIntent: notifyIntent,
  findLastIntentId: findLastIntentId
};